import { mixed, number, object, string } from "yup"

const skuModel = object({
  capacity: number().positive().required().label("SKU Capacity"),
  capacityUnit: mixed().required("Please enter a valid capacity unit"),
  name: string().min(2).max(30).label("SKU Name").required(),
  description: string().min(2).max(50).label("Description"),
  selfWeight: number()
    .positive()
    .label("Tare Weight")
    .typeError("Please enter a valid weight"),
  skuCategory: mixed().label("SKU Category"),
  stockCount: number().positive().label("Stock Count"),
  unitPrice: number().positive("Unit price should be greater than 0"),
})

export default skuModel
